import * as EventsConstants from '../constants/events-constants'
import { calendarFunctions } from '../helpers/calendar-functions';

const initialState = {
    loading: false,
    saving: false,
    eventsError: false,
    forecastError: false,
    allForecastsFetched: false,
    forecastsFetched: 0,
    updateEventsSuccess: false,
    updateEventsError: false,
    deleting: false,
    deleteEventsSuccess: false,
    deleteEventsError: false,
    errorMessage: "",
    errorStatus: 0,
    errorType: null,
    events: [],
    recurrentEvents: [],
    eventsToShow: [],
    event: null
};

export const eventsReducer = (state = initialState, action) => {
    switch(action.type) {
        case EventsConstants.FETCH_ALL_EVENTS_BEGIN:
            return {
                ...state,
                loading: true,
                eventsError: false,
            }
        case EventsConstants.FETCH_ALL_EVENTS_SUCCESS:
            return {
                ...state,
                events: action.data,
                loading: false,
                eventsError: false,
            }
        case EventsConstants.FETCH_ALL_EVENTS_FAILURE:
            return {
                ...state,
                errorType: action.error.errorType,
                errorMessage: action.error.errorMessage,
                eventsError: true,
                loading: false
            }
        case EventsConstants.FETCH_RECURRENT_EVENTS_BEGIN:
            return {
                ...state,
                loading: true,
                eventsError: false,
            }
        case EventsConstants.FETCH_RECURRENT_EVENTS_SUCCESS:
            const recurrentEvents = calendarFunctions.generateEventsForCalendarView(action.data);
            let eventsToShow = [ ...state.events, ...recurrentEvents];
            return {
                ...state,
                recurrentEvents: action.data,
                eventsToShow: calendarFunctions.formatEventsForCalendarView(eventsToShow),
                loading: false,
                eventsError: false,
            }
        case EventsConstants.FETCH_RECURRENT_EVENTS_FAILURE:
            return {
                ...state,
                errorType: action.error.errorType,
                errorMessage: action.error.errorMessage,
                eventsError: true,
                loading: false
            }
        case EventsConstants.CREATE_EVENT_BEGIN:
            return {
                ...state,
                saving: true,
                updateEventsError: false,
                updateEventsSuccess: false
            }
        case EventsConstants.CREATE_EVENT_SUCCESS:
            let events = action.data;
            if (events.length > 0 && events[0].recurrenceRule) {
                events = state.events
            }
            return {
                ...state,
                events: events,
                eventsToShow: calendarFunctions.formatEventsForCalendarView(events),
                saving: false,
                updateEventsSuccess: true
            }
        case EventsConstants.CREATE_EVENT_FAILURE:
            return {
                ...state,
                errorType: action.error.errorType,
                errorMessage: action.error.errorMessage,
                saving: false,
                updateEventsError: true,
                updateEventsSuccess: false
            }
        case EventsConstants.DELETE_EVENT_BEGIN:
            return {
                ...state,
                deleting: true,
                deleteEventsError: false,
                deleteEventsSuccess: false
            }
        case EventsConstants.DELETE_EVENT_SUCCESS:
            let newEventsData = action.data;
            if ((newEventsData.length === 0 && action.eventType === 'recurrent')
                || (newEventsData.length > 0 && newEventsData[0].recurrenceRule)) {
                newEventsData = state.events
            }
            return {
                ...state,
                events: newEventsData,
                eventsToShow: calendarFunctions.formatEventsForCalendarView(newEventsData),
                deleting: false,
                deleteEventsSuccess: true
            }
        case EventsConstants.DELETE_EVENT_FAILURE:
            return {
                ...state,
                deleting: false,
                deleteEventsError: true
            }
        case EventsConstants.FETCH_FORECASTS_BEGIN:
            return {
                ...state,
                loading: true,
                forecastsFetched: 0,
                forecastError: false,
                allForecastsFetched: false
            }
        case EventsConstants.FETCH_FORECASTS_SUCCESS:
            if (action.foreCast === 'empty') {
                return {
                    ...state,
                    allForecastsFetched: true,
                    forecastError: false,
                    loading: false
                }
            }
            const eventsWithForecasts = state.eventsToShow.concat(action.foreCast)
            const forecastsFetched = state.forecastsFetched + 1;
            const up = JSON.parse(localStorage.getItem('userProfile'));
            const activeForecasts = up.weather.filter(wF => wF.active === true);
            const allForecastsFetched = activeForecasts.length === forecastsFetched;   
            return {
                ...state,
                eventsToShow: eventsWithForecasts,
                loading: false,
                forecastsFetched,
                allForecastsFetched,
                forecastError: false,
            }
        case EventsConstants.FETCH_FORECASTS_FAILURE:
            return {
                ...state,
                errorMessage: action.error,
                forecastError: true,
                loading: false,
            }
        default: 
            return {
                ...state
            }
    }

}